import { Box, Text, Image, useDisclosure, Link, Icon, Divider } from '@chakra-ui/react';
import React from 'react';
import ShareIcon from '../../assets/Icons/share';
import { AppStoreState, useAppStore } from '../../store';
import ShareProjectModal from '../modals/ShareProjectModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXTwitter, faMedium, faDiscord } from '@fortawesome/free-brands-svg-icons';
import { faGlobe, faBook } from '@fortawesome/free-solid-svg-icons';

export default function ProjectDetails() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const projectById = useAppStore((state: AppStoreState) => state.projectById);

  console.log('projectById', projectById);

  const onShareClick = () => {
    onOpen();
  };

  const icons: any = {
    X: faXTwitter,
    medium: faMedium,
    discord: faDiscord,
    gitbook: faBook,
    website: faGlobe,
  };

  return (
    <>
      <ShareProjectModal onClose={onClose} isOpen={isOpen} onOpen={onOpen} />
      <Box
        padding="24px"
        borderRadius="16px"
        border=" 1px solid rgba(0, 0, 0, 0.10)"
        background="#FFF"
        width="100%"
        display="flex"
        flexDirection="column"
      >
        <Box
          display="flex"
          flexDirection={['column', 'column', 'row']}
          justifyContent="space-between"
          gap={['10px', '10px', 'unset']}
        >
          <Box display="flex" alignItems="center" gap="10px">
            <Box>
              <Image
                src={projectById?.Project?.logo}
                width={['30px', '50px', '84px']}
                height={['30px', '50px', '84px']}
                borderRadius="50%"
                referrerPolicy="no-referrer"
              />
            </Box>
            <Text color="rgba(0, 0, 0, 0.85)" fontSize={['20px', '36px']} fontStyle="normal" fontWeight="600">
              {projectById?.Project?.project_name}
            </Text>
          </Box>
          <Box display={['flex']} justifyContent={['flex-end']}>
            <Box
              borderRadius="12px"
              border="1px solid var(--Neutrals-Light-Gray, #E5E5E5)"
              background=" #FFF"
              height="38px"
              width="93px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              gap="5px"
              cursor="pointer"
              onClick={() => onShareClick()}
            >
              <Text fontSize="14px" fontWeight={500} color="#000">
                Share
              </Text>
              <ShareIcon />
            </Box>
          </Box>
        </Box>
        <Box
          borderRadius="32px"
          background="rgba(0, 0, 0, 0.08)"
          h="31px"
          w="112px"
          display="flex"
          justifyContent="center"
          alignItems="center"
          fontSize="12px"
          fontWeight={500}
          color="#000"
          marginTop="26px"
        >
          Created - {projectById?.Project?.establishment_date}
        </Box>
        <Text fontSize="24px" fontWeight={600} color="#000" marginTop={'18px'}>
          {projectById?.Project?.one_liner}
        </Text>
        <Text fontSize="14px" fontWeight={400} color="rgba(0, 0, 0, 0.50)" marginTop="5px">
          {projectById?.Project?.description}
        </Text>
        <Box marginTop="32px" display="flex" marginBottom="16px" alignItems="center">
          <Text color=" #797979" fontSize="12px" fontWeight={500}>
            Tags:
          </Text>
          <Box display="flex" gap="5px" marginLeft="6px">
            {projectById?.Project?.tags &&
              projectById?.Project?.tags.length > 0 &&
              projectById?.Project?.tags.map((item: any, index: React.Key | null | undefined) => (
                <Box
                  h="27px"
                  borderRadius="10px"
                  display="flex"
                  gap="4px"
                  alignItems="center"
                  justifyContent="center"
                  key={index}
                  padding="0px 14px"
                  border=" 1px solid #E5E5E5"
                  background="#FFF"
                >
                  <Text color="#797979" fontSize="12px" fontWeight={500}>
                    {item}
                  </Text>
                </Box>
              ))}
          </Box>
        </Box>
        <Divider />
        <Box marginTop="14px" display="flex" flexWrap="wrap" gap="10px">
          {projectById &&
            Object.entries(projectById?.Project?.social_media).map(([key, url]) =>
              url ? (
                <Link
                  key={key}
                  href={url}
                  isExternal
                  marginY="4px"
                  padding="8px 10px"
                  borderRadius="12px"
                  background="rgba(0, 0, 0, 0.10)"
                  display="flex"
                  gap="4px"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Icon as={FontAwesomeIcon} icon={icons[key]} />
                  {key !== 'X' && (
                    <Text marginLeft="8px" textTransform="capitalize">
                      {key}
                    </Text>
                  )}
                </Link>
              ) : null,
            )}
        </Box>
      </Box>
    </>
  );
}
